module.exports = __webpack_public_path__ + "img/1.466d8a7e.webp";